export const validateLoanForm = ({ selectedPlans, planDetails, inputs, loanPlanLabels }) => {
  const errors = [];
  const minCourseFinishDate = new Date("2009-01-01");
  const maxCourseFinishDate = new Date("2026-12-01");

  if (selectedPlans.length === 0) {
    errors.push("Please select at least one loan plan.");
  }

  selectedPlans.forEach((planKey) => {
    const planLabel = loanPlanLabels[planKey] || planKey;
    const gradDate = planDetails[planKey]?.graduationDate;
    const balance = planDetails[planKey]?.balance;
    const overpaymentAmount = planDetails[planKey]?.overpayment_amount;
    const overpaymentLumpSumWholeThing = Boolean(
      planDetails[planKey]?.overpayment_lump_sum_whole_thing
    );

    if (!gradDate) {
      errors.push(`${planLabel} Course Finish Date is required.`);
    } else if (Number.isNaN(Date.parse(gradDate))) {
      errors.push(`${planLabel} Course Finish Date must be a valid date.`);
    } else {
      const parsedGradDate = new Date(gradDate);
      if (parsedGradDate < minCourseFinishDate || parsedGradDate > maxCourseFinishDate) {
        errors.push(`${planLabel} Course Finish Date must be between January 2009 and December 2026.`);
      }
    }

    if (balance === undefined || balance === "") {
      errors.push(`${planLabel} Current Loan Balance is required.`);
    }

    if (overpaymentAmount !== undefined && overpaymentAmount !== "" && Number(overpaymentAmount) < 0) {
      errors.push(`${planLabel} Overpayment Amount cannot be negative.`);
    }

    if (
      !overpaymentLumpSumWholeThing
      && balance !== undefined
      && balance !== ""
      && overpaymentAmount !== undefined
      && overpaymentAmount !== ""
      && Number(overpaymentAmount) > Number(balance)
    ) {
      errors.push(
        `${planLabel} Overpayment Amount cannot be greater than the Loan Balance. To simulate paying off the entire loan choose One-Off Lump Sum and tick Pay Off Entire Loan`
      );
    }
  });

  if (inputs.starting_income === undefined || inputs.starting_income === "") {
    errors.push("Current Total Gross Annual Income is required.");
  }

  return errors;
};
